import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { Component, OnInit, NgModule } from '@angular/core';
import { Loader } from './loader';
import { LoaderService } from './loader.service';
import { PanelEvent } from '../PanelEvent';
import { ToastrMessagesService } from '../services/toastr-messages.service';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-loader',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit {

    public show = false;

    constructor(private loaderService: LoaderService, public panelEvent: PanelEvent) { }

    ngOnInit() {
        this.panelEvent.bufferSpinnerLoading = [];
        this.loaderService.loader.subscribe({
            next: (state: Loader) => this.show = state.show,
            error: (error) => console.error(error.error)
        });
    }
}

@NgModule({
    exports: [LoaderComponent],
    declarations: [LoaderComponent],
    imports: [ProgressSpinnerModule],
    providers: [LoaderService,ToastrMessagesService, ToastrService,]
})
export class LoaderModule { }
